import {SelectOption} from 'components/ui-kit/Select';
import {ApiFilters, InnerFilters, InnerFilterValue} from 'types/api';

export function mapFilters(filter: InnerFilters): ApiFilters {
    const mapValue = (value: InnerFilterValue) => {
        if (Array.isArray(value)) {
            // @ts-ignore
            if (value.length === 0 || value.every((elem: any) => elem == null)) {
                return value;
            }

            // if value is date range
            if (value.length === 2 && value.some((elem: any) => elem instanceof Date)) {
                const left = value[0] as Date | null;
                const right = value[1] as Date | null;

                return [
                    {
                        left: left !== null ? left?.toISOString() : new Date(0).toISOString(),
                        right: right !== null ? right?.toISOString() : new Date().toISOString(),
                    },
                ];
            }

            // if value is number range
            if (value.length === 2 && value.some((elem: any) => !isNaN(Number(elem)))) {
                return [
                    {
                        left: value[0],
                        right: value[1],
                    },
                ];
            }

            // if value is SelectOption catalog
            if (typeof value[0] === 'object' && 'value' in (value[0] as any)) {
                return (value as Array<SelectOption<any>>).map(
                    (elem: SelectOption<any>) => elem.value,
                );
            }

            return value;
        }

        // if value is SelectOption
        if (typeof value === 'object' && 'value' in value) {
            return [value.value];
        }

        return [value];
    };

    return filter.map(({id, value}) => ({
        id,
        value: mapValue(value),
    }));
}
